import type { IconSvgObject } from './types';

const FilePenIcon: IconSvgObject = [
  ["path", { d: "M4.5 13V4C4.5 2.89543 5.39543 2 6.5 2H13.5L20.5 9V20C20.5 21.1046 19.6046 22 18.5 22H11.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.5 2V7C13.5 8.10457 14.3954 9 15.5 9H20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3.5 22V19.7143L9.01225 14.202C9.14161 14.0727 9.31706 14 9.5 14C9.68294 14 9.85839 14.0727 9.98775 14.202L11.298 15.5123C11.4273 15.6416 11.5 15.8171 11.5 16C11.5 16.1829 11.4273 16.3584 11.298 16.4877L5.78571 22H3.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FilePenIcon;
